import { render, staticRenderFns } from "./createWork2.vue?vue&type=template&id=2ee28c02"
import script from "./createWork2.vue?vue&type=script&lang=js"
export * from "./createWork2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports